import { render, staticRenderFns } from "./Activity2_2Order.vue?vue&type=template&id=5d60b4fc&"
import script from "./Activity2_2Order.vue?vue&type=script&lang=js&"
export * from "./Activity2_2Order.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports